<template>
  <block-item-card
    :min-height="minBlockHeight"
    class="gradient-grey-06-bg"
    style="padding: 20px !important;"
  >
    <v-row class="header-row">
      <img
        src="/img/dashboard/liquidity_risk_set_icon.svg"
        alt="Liquidity Risk Icon"
        class="svg-icon"
      >
      <span
        class="header-row-text"
      >{{ $t('Dashboard.Banking.LiquidityRisk.Title') }}</span>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        class="pr-0"
      >
        <risk-assessment />
      </v-col>
      <v-col cols="6">
        <bank-readiness />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <social-media-mentions />
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>

import routerTabState        from '@/mixins/routerTabState'
import RiskAssessment from '@/theme/default/views/banking/dashboard/liquidity-risk/RiskAssessment.vue'
import BankReadiness from '@/theme/default/views/banking/dashboard/liquidity-risk/BankReadiness.vue'
import SocialMediaMentions
  from '@/theme/default/views/banking/dashboard/liquidity-risk/SocialMediaMentions.vue'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard.vue'

export default {
  name      : 'LiquidityRisk',
  components: {
    BlockItemCard,
    SocialMediaMentions,
    BankReadiness,
    RiskAssessment
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    niiAnalysisData: 'NII.FindNIIAnalysis'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      minBlockHeight: 700
    }
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
.header-row {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #607D8B;
  padding-left: 13px;
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.header-row-text {
  padding-left: 4px;
  color: #607D8B;
}

.icon-container {
  background-color: #607D8B;
  border-radius: 6px;
  width: 40px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
}

.svg-icon {
  /* width: 28px;
  height: 18px; */
  display: block;
}
</style>
